import { render, staticRenderFns } from "./TrainingTest.vue?vue&type=template&id=4f45858e&scoped=true&"
import script from "./TrainingTest.vue?vue&type=script&lang=js&"
export * from "./TrainingTest.vue?vue&type=script&lang=js&"
import style0 from "./TrainingTest.vue?vue&type=style&index=0&id=4f45858e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f45858e",
  null
  
)

export default component.exports